var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasStalePrinter)?_c('v-alert',{staticClass:"ma-0 sdp-health-banner",attrs:{"type":"warning","dense":"","tile":""}},[_vm._v(" "+_vm._s(_vm.bannerMessage)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }